import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { PopupStateless, Preloader } from '..';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function Popup({ isOpen, onClose, children }) {
  return (
    <PopupStateless opened={isOpen} onClose={onClose}>
      <div className={cx('container')}>{children || <Preloader />}</div>
    </PopupStateless>
  );
}

Popup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
};
